import React, { Component } from "react";
import Carousel from "nuka-carousel";
import { Popup, Image, Icon, Label } from "semantic-ui-react";
import ItemWithDimmer from "../components/ItemWithDimmerNode";

// css
import "../assets/css/CarrosselNOVO.css";
import "../assets/css/w3School.css";
import "../assets/css/trilha_aprendizado.css";

// aux
import limpar_titulo from "../utils/home_functions/limpar_titulo";
import valores_curso from "../utils/home_functions/valores_curso";
import { verify_mobile } from "../utils/Utils";

import apivoitto from "../services/apivoitto";
import CardDepoimento from "./CardDepoimento";

//Components

let faixa = {};
var titulo;
let numero_videos;
let carga_horaria;
let nivelCurso;
let slogan;
let topico1;
let topico2;
let topico3;
let frase_vagas;
let url_amigavel;

class CarroselPersonalizavel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pdd: "",
      secundarios: [],
      isMac: navigator.platform.toUpperCase().indexOf("MAC") >= 0,
      cellMac: 0,
      slideIndex: 0,
      slidesToShow: 4,
      slidesPocket: 5,
      inscricoes: [],
    };
  }

  componentDidMount() {
    this.handleScreenResize();
    window.addEventListener("resize", this.handleScreenResize);
  }

  componentWillMount() {
    if (this.props.apiGet) {
      apivoitto.get(this.props.apiGet, {}).then((v) => {
        let pdd = v.data.pdd[0];
        let secundarios = v.data.carousel;
        this.setState({ pdd, secundarios });
      });
    }
  }

  renderCenterControls(carrouselLength, itemsPerPage) {
    let carrouselButtons = Array(carrouselLength);

    for (
      let i = 0;
      i < parseInt((carrouselLength - 1) / itemsPerPage) + 1;
      i++
    ) {
      carrouselButtons[i] = i * itemsPerPage;
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <style>{`
                    .control-button {
                        opacity: 0.5;
                    }

                    .control-button:hover {
                        opacity: 1;
                    }

                    .control-button.active {
                        opacity: 1;
                    }
                `}</style>

        {carrouselButtons.map((btn) => {
          return (
            <div
              className={
                btn === this.state.slideIndex
                  ? "control-button active"
                  : "control-button"
              }
              id={"control-button-" + btn}
              key={btn}
              style={{
                backgroundColor: "black",
                width: "6px",
                height: "6px",
                marginRight: "10px",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                borderRadius: "50%",
              }}
              onClick={() => {
                for (
                  let i = 0;
                  i < parseInt((carrouselLength - 1) / itemsPerPage) + 1;
                  i++
                ) {
                  let anyButton = document.getElementById(
                    "control-button-" + i * itemsPerPage
                  );
                  anyButton.classList.remove("active");
                }

                let thisButton = document.getElementById(
                  "control-button-" + btn
                );
                thisButton.classList.add("active");

                this.setState({ slideIndex: btn });
              }}
            ></div>
          );
        })}
      </div>
    );
  }

  retorna_array_area(area) {
    return area;
  }

  verify_imagem(url = "") {
    return url.indexOf("voitto") > -1 ? url : "" + url;
  }

  renderWorkshops() {
    return this.props.cursos.map((v) => {
      return (
        <div
          style={{
            height: "180px",
            display: "inline-grid",
            alignItems: "center",
          }}
        >
          <ItemWithDimmer
            isMentoria={this.props.isMentoria != undefined ? true : false}
            restricao_premium={true}
            main={v.curso}
            premium={this.props.isPremium}
            titulo={v.curso.titulo}
            slogan={v.slogan}
            curso={v.curso}
            data={v.data}
            link={v.link}
            id={v.id}
            imagem={v.imagem}
            button_txt={v.button_txt}
          />
        </div>
      );
    });
  }

  renderPDF() {
    return this.props.cursos.map((object, key) => {
      const img = object.img
        ? object.img
        : "https://files.voitto.com.br/imagens-voitto/cursos/small/" +
          object.url_amigavel +
          ".jpg";
      const url = object.url ? object.url : `/online/assistir/${object.id}`;
      const titulo = object.titulo.substr(8, object.titulo.length);
      return (
        <div className="owl-item" style={{ width: "220px", height: "205px" }}>
          <div
            className="ui card curso-item img-shadow"
            data-position="{position}"
            data-id="b42f794ea818b4"
            style={{
              backgroundColor: "transparent",
              border: "none",
              boxShadow: "none",
              zIndex: "99999999",
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              height: "100%",
            }}
          >
            <div
              className="image"
              style={{ height: "145px", overflow: "hidden" }}
            >
              {verify_mobile() ? (
                <>
                  <Image
                    className="image_carrosel"
                    fluid
                    //label={{ as: 'a', color: faixa.color, content: faixa.content, ribbon: true, icon: faixa.icon }}
                    onError={(e) => {
                      e.target.src = e.target.src.replace("jpg", "png");
                    }}
                    onClick={() => {
                      window.open(url, "_blank");
                    }}
                    src={img}
                  />
                </>
              ) : (
                <>
                  <a target="_blank">
                    <Image
                      className="image_carrosel"
                      fluid
                      src={img}
                      onError={(e) => {
                        e.target.src = e.target.src.replace("jpg", "png");
                      }}
                      onClick={() => {
                        window.open(url, "_blank");
                      }}
                    />
                  </a>
                </>
              )}
            </div>
            <div
              style={{
                textAlign: "center",
                backgroundColor: "#212121",
                paddingTop: "15px",
              }}
            >
              <p style={{ fontSize: "16px", color: "#ffffff" }}>{titulo}</p>
            </div>
          </div>
        </div>
      );
    });
  }

  limpaNomePdf(nome) {
    return nome.replace("[eBook]", "");
  }

  renderMateriais() {
    return this.props.cursos.map((v) => {
      const subscribed = (() => {
        if (this.props.inscricao && this.props.is_aovivo) {
          return !!this.props.inscricao.find((res) => v.id === res.id_mentoria);
        }
        return false;
      })();
      return (
        <div
          style={{
            height: "140px",
            display: "inline-grid",
            alignItems: "center",
          }}
        >
          <ItemWithDimmer
            isMentoria={this.props.isMentoria ? true : false}
            restricao_premium={
              this.props.restricao_premium ? this.props.restricao_premium : true
            }
            premium={this.props.isPremium}
            main={v}
            inscricao={this.props.inscricao}
            proximaMentoria={
              this.props.proximaMentoria ? this.props.proximaMentoria : false
            }
            isSubscribed={subscribed}
            titulo={v.titulo}
            slogan={v.slogan}
            curso={v.curso}
            data={v.data}
            link={v.link}
            id={v.id}
            imagem={v.imagem}
            button_txt={
              this.props.button_txt ? this.props.button_txt : v.button_txt
            }
          />
        </div>
      );
    });
  }

  renderPocketBooks() {
    return this.props.cursos.map((v) => {
      return (
        <div className="pocket_item">
          <a href={"blog/artigo/" + v.url} target="_blank">
            <img className="pocket_img" src={v.imagem} />
          </a>
          <div className="informations_all_pocket">
            <div className="ui content desc_pocket">
              <a
                className="pocket_title"
                href={"blog/artigo/" + v.url}
                target="_blank"
              >
                {v.titulo}
              </a>
            </div>
            {v.amais}
          </div>
        </div>
      );
    });
  }

  popUpContent() {
    return (
      <div className="tooltip_content ui container media">
        {
          <div>
            <section
              onclick={() => {
                window.open(`digital/${url_amigavel}`, "_blank");
              }}
            >
              <center>
                <p className="titulo-curso-tooltip">{titulo}</p>
              </center>{" "}
              <br />
              <div className="carga-horaria">
                <div className="item-carga-tooltip item-1">
                  <div>
                    <i className="ui play icon"></i>
                    {numero_videos} aulas
                  </div>
                </div>

                <div
                  className="item-carga-tooltip item-2"
                  style={{ marginLeft: "5%" }}
                >
                  <div>
                    <i className="ui time icon"></i>
                    {carga_horaria} horas
                  </div>
                </div>

                <div
                  className="item-carga-tooltip item-3"
                  style={{ marginLeft: "5%" }}
                >
                  {nivelCurso === "" ? (
                    <div>
                      <i className="ui icon flag checkered"></i>Início Imediato
                    </div>
                  ) : (
                    <div>
                      <i className="ui icon flag checkered"></i>
                      {nivelCurso}
                    </div>
                  )}
                </div>
              </div>
              <br />
              <p className="slogan-curso-tooltip">{slogan}</p>
              <div className="items_aprendera">
                <p className="item-curso-tooltip">• {topico1}</p>

                <p className="item-curso-tooltip">• {topico2}</p>

                <p className="item-curso-tooltip">• {topico3}</p>
              </div>
              <br />
            </section>

            <center>
              <p style={{ marginTop: -20, marginBottom: 10, color: "#F26201" }}>
                {frase_vagas}
              </p>
            </center>
          </div>
        }
      </div>
    );
  }

  renderHistorias() {
    return this.props.cursos.map((json) => (
      <CardDepoimento
        isHome={true}
        nome={json.nome}
        link={json.link_yout}
        img={json.idImg}
        parafrase={json.parafrase}
      />
    ));
  }

  renderCard() {
    const item = this.props.cursos.sort((a, b) => a.ordem - b.ordem);

    return item.map((object, key) => {
      if (
        object.titulo == "ONLINE - Gestão do Tempo e Produtividade Profissional"
      ) {
        console.log(object.titulo.indexOf("COMBO"));
      }

      if (object.faixa) {
        faixa = {
          color: object.faixa.cor,
          content: object.faixa.texto,
          icon: null,
        };
      }
      if (
        object.espera != true &&
        object.titulo.indexOf("COMBO") > -1 &&
        object.destaque == "S"
      ) {
        faixa = { content: "" };
      }
      if (object.faixa.valor || object.valor == 0) {
        var divPrecos = (
          <div
            style={{
              whiteSpace: "pre",
              height: "50px",
              verticalAlign: "center",
            }}
          >
            <p
              style={{
                display: "flex",
                alignItems: "center",
                color: "#FFF",
                textDecoration: "line-through",
                marginTop:
                  object.valor == 0
                    ? verify_mobile()
                      ? "25%"
                      : "-0.5%"
                    : null,
              }}
              className="preco-parcela"
            >
              {valores_curso(object)["de_por"]}
            </p>
            <p
              style={{ display: "flex", alignItems: "center", color: "#FFF" }}
              className="preco-avista"
            >
              Por <b> {object.faixa.valor || "GRATUITO"} </b>
            </p>
          </div>
        );
      } else {
        var divPrecos = (
          <div
            style={{
              whiteSpace: "pre",
              height: "50px",
              verticalAlign: "center",
            }}
          >
            <p
              style={{ display: "flex", alignItems: "center", color: "#FFF" }}
              className="preco-corte"
            >
              {valores_curso(object)["de_por"]}
            </p>
            <p
              style={{ display: "flex", alignItems: "center", color: "#FFF" }}
              className="preco-parcela"
            >
              Por{" "}
              {object.id == "3840" ||
              object.id == "4064" ||
              object.id == "4134" ? (
                <b>12x</b>
              ) : (
                <b>10x</b>
              )}{" "}
              de <b>{valores_curso(object)["parcelado_html"]}</b>
            </p>
            <p
              style={{ display: "flex", alignItems: "center", color: "#FFF" }}
              className="preco-avista"
            >
              ou <b>{valores_curso(object)["avista"]}</b> à vista
            </p>
          </div>
        );
      }

      if (
        object.titulo == "ONLINE - Gestão do Tempo e Produtividade Profissional"
      ) {
        console.log(faixa);
      }

      {
        titulo = limpar_titulo(object.titulo);
      }
      {
        numero_videos = object.numero_videos;
      }
      {
        carga_horaria = object.carga_horaria;
      }
      {
        nivelCurso = object.nivel;
      }
      {
        slogan = object.treinamento.slogan;
      }
      {
        topico1 = object.treinamento.topico1;
      }
      {
        topico2 = object.treinamento.topico2;
      }
      {
        topico3 = object.treinamento.topico3;
      }
      {
        frase_vagas = object.frase_vagas;
      }
      {
        url_amigavel = object.url_amigavel;
      }
      return (
        <div
          className="owl-item"
          style={{ width: "220px", height: verify_mobile() ? "" : "" }}
        >
          <div
            className="ui card curso-item img-shadow"
            data-position="{position}"
            data-id="b42f794ea818b4"
            style={{
              backgroundColor: "transparent",
              border: "none",
              boxShadow: "none",
              zIndex: "99999999",
              cursor: "pointer",
            }}
          >
            {faixa != undefined &&
            faixa.content != undefined &&
            faixa.content != "" ? (
              <div className="image" style={{ height: "100%" }}>
                <a
                  target="_blank"
                  href={
                    this.props.parceiro != undefined
                      ? "/digital/" + url_amigavel + "/" + this.props.parceiro
                      : "/digital/" + url_amigavel
                  }
                >
                  {verify_mobile() ? (
                    <>
                      <Label
                        as="a"
                        style={{
                          position: "absolute",
                          zIndex: 100,
                          marginLeft: "15px",
                        }}
                        content={faixa.content}
                        color={faixa.color}
                        icon={faixa.icon}
                        ribbon
                      ></Label>
                      <Image
                        className="image_carrosel"
                        fluid
                        //label={{ as: 'a', color: faixa.color, content: faixa.content, ribbon: true, icon: faixa.icon }}
                        src={
                          "https://files.voitto.com.br/imagens-voitto/cursos/small/" +
                          url_amigavel +
                          ".jpg"
                        }
                        onError={(e) => {
                          e.target.src = e.target.src.replace("jpg", "png");
                        }}
                      />
                    </>
                  ) : (
                    <Popup
                      trigger={
                        <>
                          <Label
                            as="a"
                            style={{
                              position: "absolute",
                              zIndex: 100,
                              marginLeft: "14px",
                            }}
                            content={faixa.content}
                            color={faixa.color}
                            icon={faixa.icon}
                            ribbon
                          ></Label>

                          <Image
                            className="image_carrosel"
                            fluid
                            src={
                              "https://files.voitto.com.br/imagens-voitto/cursos/small/" +
                              url_amigavel +
                              ".jpg"
                            }
                            onError={(e) => {
                              e.target.src = e.target.src.replace("jpg", "png");
                            }}
                          />
                        </>
                      }
                      position="top center"
                    >
                      {this.popUpContent()}
                    </Popup>
                  )}
                </a>
              </div>
            ) : (
              <div className="image" style={{ height: "100%" }}>
                <a
                  target="_blank"
                  href={
                    this.props.parceiro != undefined
                      ? "/digital/" + url_amigavel + "/" + this.props.parceiro
                      : this.props.isNode
                      ? "digital-node/" + url_amigavel
                      : "/digital/" + url_amigavel
                  }
                >
                  {verify_mobile() ? (
                    <Image
                      className="image_carrosel"
                      fluid
                      src={
                        "https://files.voitto.com.br/imagens-voitto/cursos/small/" +
                        url_amigavel +
                        ".jpg"
                      }
                      onError={(e) => {
                        e.target.src = e.target.src.replace("jpg", "png");
                      }}
                    />
                  ) : (
                    <Popup
                      // flowing hoverable hideOnScroll mouseLeaveDelay={300}
                      trigger={
                        <Image
                          className="image_carrosel"
                          fluid
                          src={
                            "https://files.voitto.com.br/imagens-voitto/cursos/small/" +
                            url_amigavel +
                            ".jpg"
                          }
                          onError={(e) => {
                            e.target.src = e.target.src.replace("jpg", "png");
                          }}
                        />
                      }
                      position="top center"
                    >
                      {this.popUpContent()}
                    </Popup>
                  )}
                </a>
              </div>
            )}

            <div
              onClick={this.handleClick}
              style={{
                padding: "0",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "spaceBetween",
              }}
              className="content"
            >
              <center>
                <p
                  style={{
                    height: verify_mobile() ? "40px" : "60px",
                    color: "#FFF",
                    height: verify_mobile() ? "23px" : "80px",
                    color: "white",
                    fontSize: "14px",
                    justifyContent: "center",
                    marginTop: "5px",
                    marginRight: verify_mobile() ? "8%" : null,
                  }}
                >
                  {" "}
                  {slogan}{" "}
                </p>
              </center>

              <div className="meta">
                <div
                  className="precos-div"
                  style={{
                    width: verify_mobile() ? null : "95%",
                    marginTop: verify_mobile() ? "8%" : "-2%",
                  }}
                >
                  <div>{divPrecos}</div>

                  <div
                    className="btn_link"
                    style={verify_mobile() ? { display: "flex" } : null}
                  >
                    {verify_mobile() ? (
                      <div style={{ alignSelf: "center" }}>
                        <a
                          target="_blank"
                          href={`digital/${
                            this.props.parceiro != undefined
                              ? url_amigavel + "/" + this.props.parceiro
                              : url_amigavel
                          }`}
                        >
                          <button className="ui tiny orange button nuka">
                            Ver mais
                          </button>{" "}
                        </a>
                      </div>
                    ) : (
                      <div
                        style={
                          window.innerWidth > 1390
                            ? { alignSelf: "center", width: "70px" }
                            : null
                        }
                      >
                        <a
                          target="_blank"
                          href={`digital/${
                            this.props.parceiro != undefined
                              ? url_amigavel + "/" + this.props.parceiro
                              : url_amigavel
                          }`}
                        >
                          <button className="ui tiny orange button">
                            Ver mais
                          </button>{" "}
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  }

  render_assistir_card(arr) {
    return arr.map((v) => (
      <ItemWithDimmer
        superHeihgt={true}
        main={v}
        link={"online/assistir/" + v.id}
        imagem={`https://files.voitto.com.br/imagens-voitto/cursos/small/${v.url_amigavel}.jpg?size=300`}
        button_txt={`Assistir`}
      />
    ));
  }

  renderMainRecentlyArticleImage() {
    if (this.state.pdd != "") {
      let v = this.state.pdd;
      return (
        <a target="_blank" href={`blog/artigo/${v.url}`}>
          <div className="w3-display-container w3-text-white">
            <img
              className="d-block w-100 black-bg"
              src={this.verify_imagem(v.imagem)}
              alt={v.titulo}
            />
            <div
              className="w3-display-bottommiddle w3-xlarge titulo"
              style={{
                marginBottom: verify_mobile() ? "20%" : "7%",
                width: "fit-content",
                zIndex: "1",
              }}
            >
              <h3>{v.titulo}</h3>
            </div>
            <br />
            <div
              className="w3-display-bottommiddle w3-container"
              style={{ marginBottom: "5%", zIndex: "1" }}
            >
              <p>{v.consultor}</p>
            </div>
            <div
              className="w3-display-bottommiddle w3-container"
              style={{
                height: "30%",
                backgroundColor: "rgba(0,0,0,0.5)",
                minWidth: "-webkit-fill-available",
                marginBottom: "1%",
              }}
            />
          </div>
        </a>
      );
    }
  }

  renderSecondaryRecentlyArticleImages() {
    if (this.state.secundarios.length > 0) {
      return this.state.secundarios.map((v, f) => {
        return (
          <a target="_blank" href={`blog/artigo/${v.url}`}>
            <div className="w3-display-container w3-text-white">
              <img
                className="d-block w-100 black-bg"
                src={this.verify_imagem(v.imagem)}
                alt={v.titulo}
              />
              <div
                className="w3-display-bottommiddle w3-xlarge"
                style={{
                  marginBottom: "7%",
                  width: "fit-content",
                  zIndex: "1",
                }}
              >
                <h3>{v.titulo}</h3>
              </div>
              <br />
              <div
                className="w3-display-bottommiddle w3-container"
                style={{ marginBottom: "5%", zIndex: "1" }}
              >
                <p>{v.consultor}</p>
              </div>
              <div
                className="w3-display-bottommiddle w3-container"
                style={{
                  height: "30%",
                  backgroundColor: "rgba(0,0,0,0.5)",
                  minWidth: "-webkit-fill-available",
                  marginBottom: "1%",
                }}
              />
            </div>
          </a>
        );
      });
    }
  }

  handleScreenResize = () => {
    if (window.innerWidth < 645) {
      this.setState({
        slidesToShow: 1,
        slidesPocket: 1,
        cellMac: 30,
      });

      return;
    }
    if (window.innerWidth < 992) {
      this.setState({
        slidesToShow: 2,
        slidesPocket: 2,
        cellMac: 30,
      });

      return;
    }
    if (window.innerWidth < 1200) {
      this.setState({
        slidesToShow: 3,
        slidesPocket: 3,
        cellMac: 30,
      });

      return;
    }
    if (window.innerWidth < 1400) {
      this.setState({
        slidesToShow: 4,
        slidesPocket: 4,
        cellMac: 30,
      });

      return;
    }

    this.setState({
      slidesToShow: 4,
      slidesPocket: 5,
      cellMac: 0,
    });
  };

  render() {
    return (
      <div>
        <style>
          {`

                        @media screen and (max-width: 890px){
                            .depoimentos_container{
                                width: 90% !important;
                            }

                            .ebooksdiv{
                              display: flex;
                              align-items: center;
                              justify-content: center;
                            }

                            .depoimentos_container .slider-frame{
                                margin-right: 9% !important;
                            }

                            .slider-control-centerright{
                                top: auto !important;
                                transform: ${
                                  verify_mobile()
                                    ? "translateY(-90%)!important"
                                    : "translateY(-50%) !important"
                                };

                            }

                            .slider-control-centerleft{
                                top: auto !important;
                                transform: ${
                                  verify_mobile()
                                    ? "translateY(-90%)!important"
                                    : "translateY(-50%) !important"
                                };
                            }


                            .slider-frame {
                                margin-right: 0% !important;
                            }

                            .inscricao_topo{
                                margin-top: -5%;
                            }
                            .slider{
                                margin-top: ${verify_mobile() && "5%"}
                            }
                        }

                        @media screen and (min-width: 320px) and (max-width: 400px){
                            .slider-frame {
                                /*margin-left: 7% !important;*/
                            }      
                        }

                        @media screen and (min-width: 401px) and (max-width: 890px){
                            .slider-frame {
                                margin-left: 9% !important;
                            } 

                            .youtube_voitto{
                                margin-bottom: 1% !important;
                            }
                        }
                    `}
        </style>

        {this.props.pdf ? (
          <div className="ebooksdiv">
            {!verify_mobile() ? (
              <Carousel
                slidesToShow={this.state.slidesToShow}
                slidesToScroll={1}
                cellAlign="left"
                wrapAround={this.props.wrapAround == false ? false : true}
                cellSpacing={window.innerWidth > 1390 ? 15 : 20}
                framePadding={this.props.padding}
                renderCenterLeftControls={
                  this.props.botaoEsquerdo
                    ? this.props.botaoEsquerdo
                    : ({ previousSlide }) => (
                        <button
                          onClick={previousSlide}
                          style={{ borderStyle: "none", background: "#F2711C" }}
                        >
                          <b className="icon-prev-mobile">&lt;</b>
                        </button>
                      )
                }
                renderCenterRightControls={
                  this.props.botaoDireito
                    ? this.props.botaoDireito
                    : ({ nextSlide }) => (
                        <button
                          onClick={nextSlide}
                          style={{ borderStyle: "none", background: "#F2711C" }}
                        >
                          <b className="icon-next-mobile">&gt;</b>
                        </button>
                      )
                }
                afterSlide={this.handleAfterSlide}
              >
                {this.renderPDF()}
              </Carousel>
            ) : (
              <Carousel
                slidesToShow={1}
                slidesToScroll={1}
                cellAlign="left"
                wrapAround={this.props.wrapAround == false ? false : true}
                cellSpacing={window.innerWidth > 1390 ? 15 : 20}
                framePadding={this.props.padding}
                // slidesToShow={1}
                // slidesToScroll={1}
                // cellAlign="center"
                // wrapAround={true}
                // cellSpacing={20}

                renderCenterLeftControls={
                  this.props.botaoEsquerdo
                    ? this.props.botaoEsquerdo
                    : ({ previousSlide }) => (
                        <Icon
                          name="chevron left"
                          color="white"
                          style={{ color: "#fff" }}
                          onClick={previousSlide}
                        ></Icon>
                      )
                }
                renderCenterRightControls={
                  this.props.botaoDireito
                    ? this.props.botaoDireito
                    : ({ nextSlide }) => (
                        <Icon
                          name="chevron right"
                          color="white"
                          style={{ color: "#fff" }}
                          onClick={nextSlide}
                        ></Icon>
                      )
                }
                renderBottomCenterControls={false}
                afterSlide={this.handleAfterSlide}
              >
                {this.renderPDF()}
              </Carousel>
            )}
          </div>
        ) : this.props.venda ? (
          this.renderCard(this.props.area) != undefined ? (
            !verify_mobile() ? (
              <div>
                <Carousel
                  slidesToShow={this.state.slidesToShow}
                  slidesToScroll={1}
                  cellAlign="left"
                  wrapAround={this.props.wrapAround == false ? false : true}
                  cellSpacing={window.innerWidth > 1390 ? 15 : 20}
                  framePadding={this.props.padding}
                  style={{ height: "48vh" }}
                  renderCenterLeftControls={
                    this.props.botaoEsquerdo
                      ? this.props.botaoEsquerdo
                      : ({ previousSlide }) => (
                          <button
                            onClick={previousSlide}
                            style={{
                              borderStyle: "none",
                              background: "#F2711C",
                            }}
                          >
                            <b className="icon-prev-mobile">&lt;</b>
                          </button>
                        )
                  }
                  renderCenterRightControls={
                    this.props.botaoDireito
                      ? this.props.botaoDireito
                      : ({ nextSlide }) => (
                          <button
                            onClick={nextSlide}
                            style={{
                              borderStyle: "none",
                              background: "#F2711C",
                            }}
                          >
                            <b className="icon-next-mobile">&gt;</b>
                          </button>
                        )
                  }
                  renderBottomCenterControls={false}
                  afterSlide={this.handleAfterSlide}
                >
                  {this.renderCard()}
                </Carousel>
              </div>
            ) : (
              <div>
                <Carousel
                  slidesToShow={1}
                  slidesToScroll={1}
                  cellAlign="center"
                  wrapAround={true}
                  cellSpacing={20}
                  style={{ height: "48vh" }}
                  renderCenterLeftControls={({ previousSlide }) => (
                    <Icon
                      name="chevron left"
                      style={{ color: "#fff" }}
                      color="white"
                      onClick={previousSlide}
                    ></Icon>
                  )}
                  renderCenterRightControls={({ nextSlide }) => (
                    <Icon
                      name="chevron right"
                      style={{ color: "#fff" }}
                      color="white"
                      onClick={nextSlide}
                    ></Icon>
                  )}
                  renderBottomCenterControls={false}
                >
                  {this.renderCard()}
                </Carousel>
              </div>
            )
          ) : null
        ) : this.props.blackfriday ? (
          this.renderCard(this.props.area) != undefined ? (
            !verify_mobile() ? (
              <Carousel
                slidesToShow={this.state.slidesToShow}
                slidesToScroll={1}
                cellAlign="left"
                wrapAround={this.props.wrapAround == false ? false : true}
                cellSpacing={window.innerWidth > 1390 ? 15 : 20}
                framePadding={this.props.padding}
                disableAnimation={true}
                heightMode={"current"}
                renderCenterLeftControls={
                  this.props.botaoEsquerdo
                    ? this.props.botaoEsquerdo
                    : ({ previousSlide }) => (
                        <button
                          onClick={previousSlide}
                          style={{ borderStyle: "none", background: "#F2711C" }}
                        >
                          <b className="icon-prev-mobile">&lt;</b>
                        </button>
                      )
                }
                renderCenterRightControls={
                  this.props.botaoDireito
                    ? this.props.botaoDireito
                    : ({ nextSlide }) => (
                        <button
                          onClick={nextSlide}
                          style={{ borderStyle: "none", background: "#F2711C" }}
                        >
                          <b className="icon-next-mobile">&gt;</b>
                        </button>
                      )
                }
                renderBottomCenterControls={false}
                afterSlide={this.handleAfterSlide}
              >
                {this.renderCard()}
              </Carousel>
            ) : (
              <Carousel
                slidesToShow={1}
                slidesToScroll={1}
                cellAlign="center"
                wrapAround={true}
                cellSpacing={20}
                framePadding={this.props.padding}
                disableAnimation={true}
                className="carrossel-depoimentos-medico"
                renderCenterLeftControls={({ previousSlide }) => (
                  <Icon
                    name="chevron left"
                    style={{ color: "#fff" }}
                    color="white"
                    onClick={previousSlide}
                  ></Icon>
                )}
                renderCenterRightControls={({ nextSlide }) => (
                  <Icon
                    name="chevron right"
                    style={{ color: "#fff" }}
                    color="white"
                    onClick={nextSlide}
                  ></Icon>
                )}
                renderBottomCenterControls={false}
              >
                {this.renderCard()}
              </Carousel>
            )
          ) : null
        ) : this.props.materiais ? (
          this.props.workshop ? (
            <>
              {!verify_mobile() ? (
                this.props.cursos.length > 0 ? (
                  <Carousel
                    cellSpacing={15}
                    framePadding={"4.5%"}
                    slidesToShow={this.state.isMac ? 4 : 3}
                    slidesToShow={this.state.isMac ? 4 : 3}
                    slidesToScroll={1}
                    cellAlign="left"
                    wrapAround={false}
                    disableAnimation={true}
                    renderCenterLeftControls={
                      this.props.botaoEsquerdo
                        ? this.props.botaoEsquerdo
                        : ({ previousSlide }) => (
                            <button
                              style={{ cursor: "pointer" }}
                              onClick={previousSlide}
                            >
                              <span
                                aria-label="Previous"
                                style={{ fontSize: "40px" }}
                              >
                                ‹
                              </span>
                            </button>
                          )
                    }
                    renderCenterRightControls={
                      this.props.botaoDireito
                        ? this.props.botaoDireito
                        : ({ nextSlide }) => (
                            <button
                              style={{ cursor: "pointer" }}
                              onClick={nextSlide}
                            >
                              <span
                                aria-label="Next"
                                style={{ fontSize: "40px" }}
                              >
                                ›
                              </span>
                            </button>
                          )
                    }
                  >
                    {this.renderWorkshops()}
                  </Carousel>
                ) : null
              ) : this.props.cursos.length > 0 ? (
                <Carousel
                  cellSpacing={15}
                  framePadding={"4.5%"}
                  slidesToShow={1}
                  slidesToShow={1}
                  slidesToScroll={1}
                  cellAlign="left"
                  wrapAround={false}
                  disableAnimation={true}
                  renderCenterLeftControls={
                    this.props.botaoEsquerdo
                      ? this.props.botaoEsquerdo
                      : ({ previousSlide }) => (
                          <button
                            style={{ cursor: "pointer" }}
                            onClick={previousSlide}
                          >
                            <span
                              aria-label="Previous"
                              style={{ fontSize: "40px" }}
                            >
                              ‹
                            </span>
                          </button>
                        )
                  }
                  renderCenterRightControls={
                    this.props.botaoDireito
                      ? this.props.botaoDireito
                      : ({ nextSlide }) => (
                          <button
                            style={{ cursor: "pointer" }}
                            onClick={nextSlide}
                          >
                            <span
                              aria-label="Next"
                              style={{ fontSize: "40px" }}
                            >
                              ›
                            </span>
                          </button>
                        )
                  }
                >
                  {this.renderWorkshops()}
                </Carousel>
              ) : null}
            </>
          ) : this.props.materiais ? (
            this.props.cursos.length > 0 ? (
              <Carousel
                cellSpacing={15}
                framePadding={"7.5%"}
                slidesToShow={this.state.slidesToShow}
                slidesToScroll={1}
                cellAlign="left"
                wrapAround={false}
                disableAnimation={true}
                renderCenterLeftControls={
                  this.props.botaoEsquerdo
                    ? this.props.botaoEsquerdo
                    : ({ previousSlide }) => (
                        <button
                          style={{ cursor: "pointer" }}
                          onClick={previousSlide}
                        >
                          <span
                            aria-label="Previous"
                            style={{ fontSize: "40px" }}
                          >
                            ‹
                          </span>
                        </button>
                      )
                }
                renderCenterRightControls={
                  this.props.botaoDireito
                    ? this.props.botaoDireito
                    : ({ nextSlide }) => (
                        <button
                          style={{ cursor: "pointer" }}
                          onClick={nextSlide}
                        >
                          <span aria-label="Next" style={{ fontSize: "40px" }}>
                            ›
                          </span>
                        </button>
                      )
                }
              >
                {this.renderMateriais()}
              </Carousel>
            ) : null
          ) : this.props.isPocket && this.props.pocketArea ? (
            this.props.cursos != undefined ? (
              <Carousel
                cellSpacing={this.state.isMac ? this.state.cellMac : 20}
                framePadding={this.state.isMac ? 35 : "0 3% 0 5%"}
                slidesToShow={this.state.isMac ? 5 : this.state.slidesPocket}
                slidesToScroll={1}
                cellAlign="left"
                wrapAround={true}
                disableAnimation={false}
                renderCenterLeftControls={
                  this.props.botaoEsquerdo
                    ? this.props.botaoEsquerdo
                    : ({ previousSlide }) => (
                        <button
                          style={{ cursor: "pointer" }}
                          onClick={previousSlide}
                        >
                          <span
                            aria-label="Previous"
                            style={{ fontSize: "40px" }}
                          >
                            ‹
                          </span>
                        </button>
                      )
                }
                renderCenterRightControls={
                  this.props.botaoDireito
                    ? this.props.botaoDireito
                    : ({ nextSlide }) => (
                        <button
                          style={{ cursor: "pointer" }}
                          onClick={nextSlide}
                        >
                          <span aria-label="Next" style={{ fontSize: "40px" }}>
                            ›
                          </span>
                        </button>
                      )
                }
              >
                {this.renderPocketBooks()}
              </Carousel>
            ) : null
          ) : this.props.isPocket && !this.props.pocketArea ? (
            this.props.cursos.length > 0 ? (
              <Carousel
                cellSpacing={this.state.isMac ? 50 : 20}
                interval={null}
                framePadding={this.state.isMac ? 60 : "0 3% 0 6%"}
                slidesToShow={this.state.isMac ? 5 : this.state.slidesPocket}
                slidesToScroll={1}
                cellAlign="left"
                wrapAround={true}
                disableAnimation={false}
                renderCenterLeftControls={
                  this.props.botaoEsquerdo
                    ? this.props.botaoEsquerdo
                    : ({ previousSlide }) => (
                        <button
                          style={{ cursor: "pointer" }}
                          onClick={previousSlide}
                        >
                          <span
                            aria-label="Previous"
                            style={{ fontSize: "40px" }}
                          >
                            ‹
                          </span>
                        </button>
                      )
                }
                renderCenterRightControls={
                  this.props.botaoDireito
                    ? this.props.botaoDireito
                    : ({ nextSlide }) => (
                        <button
                          style={{ cursor: "pointer" }}
                          onClick={nextSlide}
                        >
                          <span aria-label="Next" style={{ fontSize: "40px" }}>
                            ›
                          </span>
                        </button>
                      )
                }
              >
                {this.renderPocketBooks()}
              </Carousel>
            ) : null
          ) : this.props.blog != undefined ? (
            this.props.blog == "main" ? (
              <Carousel
                slidesToShow={1}
                slidesToScroll={0}
                cellAlign="center"
                disableEdgeSwiping={true}
                disableAnimation={true}
                withoutControls={true}
              >
                {this.renderMainRecentlyArticleImage()}
              </Carousel>
            ) : (
              <Carousel
                slidesToShow={1}
                slidesToScroll={1}
                cellAlign="center"
                wrapAround={true}
                autoplay={true}
                slideWidth={1.1}
                renderCenterRightControls={false}
                renderCenterLeftControls={false}
              >
                {this.renderSecondaryRecentlyArticleImages()}
              </Carousel>
            )
          ) : this.props.isDepoimentos && this.props.cursos ? (
            !verify_mobile() ? (
              <div>
                <Carousel
                  slidesToShow={this.state.slidesToShow}
                  slidesToScroll={this.props.slidesToScroll}
                  cellAlign="left"
                  wrapAround={this.props.wrapAround == false ? false : true}
                  cellSpacing={window.innerWidth > 1390 ? 15 : 20}
                  framePadding={this.props.padding}
                  disableAnimation={true}
                  heightMode={"current"}
                  renderCenterLeftControls={
                    this.props.botaoEsquerdo ? this.props.botaoEsquerdo : null
                  }
                  renderCenterRightControls={
                    this.props.botaoDireito ? this.props.botaoDireito : null
                  }
                  renderBottomCenterControls={false}
                  slideIndex={this.state.slideIndex}
                  afterSlide={this.handleAfterSlide}
                >
                  {this.renderHistorias()}
                </Carousel>

                {this.renderCenterControls(
                  this.props.cursos.length,
                  this.state.slidesToShow
                )}
              </div>
            ) : (
              <div>
                <Carousel
                  slidesToShow={1}
                  slidesToScroll={1}
                  cellAlign="center"
                  wrapAround={true}
                  cellSpacing={20}
                  framePadding={this.props.padding}
                  disableAnimation={true}
                  renderCenterLeftControls={({ previousSlide }) => (
                    <Icon name="chevron left" onClick={previousSlide}></Icon>
                  )}
                  renderCenterRightControls={({ nextSlide }) => (
                    <Icon name="chevron right" onClick={nextSlide}></Icon>
                  )}
                  renderBottomCenterControls={false}
                  slideIndex={this.state.slideIndex}
                >
                  {this.renderHistorias()}
                </Carousel>
              </div>
            )
          ) : !verify_mobile() ? (
            <Carousel
              slidesToShow={this.state.slidesToShow}
              slidesToScroll={this.props.slidesToScroll}
              cellAlign="left"
              wrapAround={this.props.wrapAround == false ? false : true}
              cellSpacing={window.innerWidth > 1390 ? 2 : 5}
              framePadding={this.props.padding}
              disableAnimation={true}
              ref={(c) => (this.carousel = c)}
              style={{ minHeight: "27vh" }}
              heightMode="current"
              renderCenterLeftControls={
                this.props.botaoEsquerdo
                  ? this.props.botaoEsquerdo
                  : ({ previousSlide }) => (
                      <button
                        onClick={previousSlide}
                        style={{ borderStyle: "none", background: "#F2711C" }}
                      >
                        <b className="icon-prev-mobile">&lt;</b>
                      </button>
                    )
              }
              renderCenterRightControls={
                this.props.botaoDireito
                  ? this.props.botaoDireito
                  : ({ nextSlide }) => (
                      <button
                        onClick={nextSlide}
                        style={{ borderStyle: "none", background: "#F2711C" }}
                      >
                        <b className="icon-next-mobile">&gt;</b>
                      </button>
                    )
              }
              renderBottomCenterControls={false}
              afterSlide={this.handleAfterSlide}
            >
              {this.render_assistir_card(this.props.cursos)}
            </Carousel>
          ) : (
            <Carousel
              slidesToShow={1}
              slidesToScroll={1}
              cellAlign="center"
              wrapAround={true}
              cellSpacing={20}
              framePadding={this.props.padding}
              disableAnimation={true}
              style={{ minHeight: "27vh" }}
              renderCenterLeftControls={({ previousSlide }) => (
                <Icon name="chevron left" onClick={previousSlide}></Icon>
              )}
              renderCenterRightControls={({ nextSlide }) => (
                <Icon name="chevron right" onClick={nextSlide}></Icon>
              )}
              renderBottomCenterControls={false}
            >
              {this.render_assistir_card(this.props.cursos)}
            </Carousel>
          )
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default CarroselPersonalizavel;
